// @ts-nocheck

import { NetworkActionTypes } from '../types/actions/network';
import { NetworkStatuses } from '../types/network';

export const networkInitialState = NetworkStatuses.CONNECTING;

export default (state = networkInitialState, action) => {
  if (state === NetworkStatuses.DISCONNECTED) {
    if (action.type === NetworkActionTypes.CONNECT || action.type === NetworkActionTypes.RECONNECT) {
      return NetworkStatuses.CONNECTING;
    }
    return state;
  }
  if (state === NetworkStatuses.CONNECTING) {
    if (action.type === NetworkActionTypes.CONNECTED) {
      return NetworkStatuses.CONNECTED;
    }
    if (action.type === NetworkActionTypes.CLOSE) {
      return NetworkStatuses.DISCONNECTED;
    }
    if (action.type === NetworkActionTypes.DISCONNECTED) {
      return NetworkStatuses.DISCONNECTED;
    }
    return state;
  }
  if (state === NetworkStatuses.CONNECTED) {
    if (action.type === NetworkActionTypes.CLOSE || action.type === NetworkActionTypes.DISCONNECTED) {
      return NetworkStatuses.DISCONNECTED;
    }
    return state;
  }
  return state;
};
